"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GridColumnDestination = void 0;
var tslib_1 = require("tslib");
var destination_1 = require("../../destination");
var GridColumnDestination = (function (_super) {
    tslib_1.__extends(GridColumnDestination, _super);
    function GridColumnDestination(data, tableGrid) {
        var _this = _super.call(this, data) || this;
        _this.tableGrid = tableGrid;
        return _this;
    }
    Object.defineProperty(GridColumnDestination.prototype, "elementHandlerTable", {
        get: function () {
            return {};
        },
        enumerable: false,
        configurable: true
    });
    GridColumnDestination.prototype.processElementOpen = function (reader) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                this.tableGrid.push(this.data.readerHelper.getWpSTIntegerValue(reader, 'w'));
                return [2];
            });
        });
    };
    return GridColumnDestination;
}(destination_1.ElementDestination));
exports.GridColumnDestination = GridColumnDestination;
